import { lowlight } from "lowlight/lib/core"

import bash from "highlight.js/lib/languages/bash"
import c from "highlight.js/lib/languages/c"
import clojure from "highlight.js/lib/languages/clojure"
import csharp from "highlight.js/lib/languages/csharp"
import css from "highlight.js/lib/languages/css"
import elixir from "highlight.js/lib/languages/elixir"
import go from "highlight.js/lib/languages/go"
import haskell from "highlight.js/lib/languages/haskell"
import html from "highlight.js/lib/languages/xml"
import java from "highlight.js/lib/languages/java"
import js from "highlight.js/lib/languages/javascript"
import julia from "highlight.js/lib/languages/julia"
import latex from "highlight.js/lib/languages/latex"
import lua from "highlight.js/lib/languages/lua"
import nim from "highlight.js/lib/languages/nim"
import nix from "highlight.js/lib/languages/nix"
import perl from "highlight.js/lib/languages/perl"
import python from "highlight.js/lib/languages/python"
import r from "highlight.js/lib/languages/r"
import ruby from "highlight.js/lib/languages/ruby"
import rust from "highlight.js/lib/languages/rust"
import scala from "highlight.js/lib/languages/scala"
import sql from "highlight.js/lib/languages/sql"
import swift from "highlight.js/lib/languages/swift"
import ts from "highlight.js/lib/languages/typescript"

export default function lowlightSetup() {
  lowlight.registerLanguage("bash", bash)
  lowlight.registerLanguage("c", c)
  lowlight.registerLanguage("clojure", clojure)
  lowlight.registerLanguage("csharp", csharp)
  lowlight.registerLanguage("css", css)
  lowlight.registerLanguage("elixir", elixir)
  lowlight.registerLanguage("go", go)
  lowlight.registerLanguage("haskell", haskell)
  lowlight.registerLanguage("html", html)
  lowlight.registerLanguage("java", java)
  lowlight.registerLanguage("js", js)
  lowlight.registerLanguage("julia", julia)
  lowlight.registerLanguage("latex", latex)
  lowlight.registerLanguage("lua", lua)
  lowlight.registerLanguage("nim", nim)
  lowlight.registerLanguage("nix", nix)
  lowlight.registerLanguage("perl", perl)
  lowlight.registerLanguage("python", python)
  lowlight.registerLanguage("r", r)
  lowlight.registerLanguage("ruby", ruby)
  lowlight.registerLanguage("rust", rust)
  lowlight.registerLanguage("scala", scala)
  lowlight.registerLanguage("sql", sql)
  lowlight.registerLanguage("swift", swift)
  lowlight.registerLanguage("ts", ts)
}
